module.exports = __webpack_public_path__ + "static/media/41_RamonaKamminski_webfinal.76eeee7d.jpg";